module.exports = __webpack_public_path__ + "static/media/table_column_name_edit.7b465a5e.png";